import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-plams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-plams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { Validators } from "@angular/forms";
import { CreateApplicationDetailsPlamsConstants } from "./create-application-details-plams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { PropertyAndLeaseService } from "../../../../shared/services/modules/property-and-lease.service";
import { DatePipe } from "@angular/common";
export let CreateApplicationDetailsPlamsComponent = class CreateApplicationDetailsPlamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    propertyAndLeaseService;
    datePipe;
    detailsForm;
    validationMessages = CreateApplicationDetailsPlamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionLabel = CreateApplicationDetailsPlamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsPlamsConstants.APPLICATION_TYPE_LABEL;
    leaseLabel = CreateApplicationDetailsPlamsConstants.LEASE_LABEL;
    drawPolyonLabel = CreateApplicationDetailsPlamsConstants.DRAW_POLYGON_LABEL;
    polygonDrawnLabel = CreateApplicationDetailsPlamsConstants.POLYGON_DRAWN_LABEL;
    leaseTypeLabel = CreateApplicationDetailsPlamsConstants.LEASE_TYPE_LABEL;
    leaseReasonTypeLabel = CreateApplicationDetailsPlamsConstants.LEASE_REASON_LABEL;
    lesseeTypeTypeLabel = CreateApplicationDetailsPlamsConstants.LESSEE_TYPE_LABEL;
    lesseeLabel = CreateApplicationDetailsPlamsConstants.LESSEE_LABEL;
    alienationLabel = CreateApplicationDetailsPlamsConstants.ALIENATION_LABEL;
    saleAmountLabel = CreateApplicationDetailsPlamsConstants.SALE_AMOUNT_LABEL;
    dateofDeedTransferLabel = CreateApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_LABEL;
    evaluationAmountLabel = CreateApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_LABEL;
    acquisitionLabel = CreateApplicationDetailsPlamsConstants.ACQUISITION_LABEL;
    buyerLabel = CreateApplicationDetailsPlamsConstants.BUYER_LABEL;
    sellerLabel = CreateApplicationDetailsPlamsConstants.SELLER_LABEL;
    referenceNumberLabel = CreateApplicationDetailsPlamsConstants.REFERENCE_NUMBER_LABEL;
    descriptionFormControlName = CreateApplicationDetailsPlamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsPlamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    leaseTypeFormControlName = CreateApplicationDetailsPlamsConstants.LEASE_TYPE_FORM_CONTROL_NAME;
    leaseReasonFormControlName = CreateApplicationDetailsPlamsConstants.LEASE_REASON_FORM_CONTROL_NAME;
    lesseeTypeFormControlName = CreateApplicationDetailsPlamsConstants.LESSEE_TYPE_FORM_CONTROL_NAME;
    lesseeFormControlName = CreateApplicationDetailsPlamsConstants.LESSEE_FORM_CONTROL_NAME;
    saleAmountAlienationFormControlName = CreateApplicationDetailsPlamsConstants.SALE_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    dateofDeedAlienationTransferFormControlName = CreateApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_ALIENATION_FORM_CONTROL_NAME;
    evaluationAmountAlienationFormControlName = CreateApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_ALIENATION_FORM_CONTROL_NAME;
    buyerFormControlName = CreateApplicationDetailsPlamsConstants.BUYER_FORM_CONTROL_NAME;
    saleAmountFormControlName = CreateApplicationDetailsPlamsConstants.SALE_AMOUNT_FORM_CONTROL_NAME;
    dateofDeedTransferFormControlName = CreateApplicationDetailsPlamsConstants.DATE_OF_DEED_TRANSFER_FORM_CONTROL_NAME;
    evaluationAmountFormControlName = CreateApplicationDetailsPlamsConstants.EVALUATION_AMOUNT_FORM_CONTROL_NAME;
    sellerFormControlName = CreateApplicationDetailsPlamsConstants.SELLER_FORM_CONTROL_NAME;
    referenceNumberControlName = CreateApplicationDetailsPlamsConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    copyApplicantToLesseeLabel = CreateApplicationDetailsPlamsConstants.COPY_APPLICANT_TO_LESSEE_LABEL;
    copyApplicantToBuyerLabel = CreateApplicationDetailsPlamsConstants.COPY_APPLICANT_TO_BUYER_LABEL;
    copyApplicantToSellerLabel = CreateApplicationDetailsPlamsConstants.COPY_APPLICANT_TO_SELLER_LABEL;
    leaseAreaDrawn = false;
    applicationTypes = [];
    leaseTypes = [];
    lesseeTypes = [];
    lesseeDisableFilterBy = true;
    lesseeDisableAdd = false;
    lesseeDisableEditing = false;
    lesseeShowGroupsDropdown = true;
    lesseeGroups = [];
    lesseeListLabel = "Lessee";
    buyerDisableFilterBy = true;
    buyerDisableAdd = false;
    buyerDisableEditing = false;
    buyerShowGroupsDropdown = true;
    buyerGroups = [];
    buyerListLabel = "Buyer";
    sellerDisableFilterBy = true;
    sellerDisableAdd = false;
    sellerDisableEditing = false;
    sellerShowGroupsDropdown = true;
    sellerGroups = [];
    sellerListLabel = "Seller";
    showRefNumber = false;
    fullApplicationCheckRequired = false;
    requiredClass = SharedConstants.CLASS_REQUIRED_TEXT;
    requiredText = SharedConstants.REQUIRED_TEXT_INDICATOR;
    descriptionPlaceholder = "Enter description";
    inputID = SharedConstants.CLASS_DESCRIPTION_TEXT;
    applicationType = null;
    applicants;
    jobId = null;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, propertyAndLeaseService, datePipe) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.propertyAndLeaseService = propertyAndLeaseService;
        this.datePipe = datePipe;
        this.getMetadata();
    }
    ngOnInit() {
        this.getLookups();
        this.getApplicants();
        this.initForm();
    }
    loadMetadata(stepMeta) {
        this.lesseeGroups = stepMeta.lesseeGroup;
        this.buyerGroups = stepMeta.buyerGroup;
        this.sellerGroups = stepMeta.sellerGroup;
        this.changeDetectorRef.markForCheck();
    }
    getApplicants() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((app) => {
            this.applicants = app?.applicant;
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq 'ApplicationType' or name eq 'LeaseType' or name eq 'LesseeType')`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        this.leaseTypes = [];
        this.lesseeTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LeaseType") {
                    this.leaseTypes.push(JSON.parse(item.content));
                }
                if (item.name === "LesseeType") {
                    this.lesseeTypes.push(JSON.parse(item.content));
                }
            });
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.jobId = application.jobId;
        this.leaseAreaDrawn = false;
        this.applicants = this.selectedApplication?.applicant;
        // checks the application has application details set
        if (application.applicationType) {
            this.applicationType = application.applicationType;
            this.detailsForm.get(this.applicationTypeFormControlName).enable();
            this.applicationTypes.forEach(item => {
                if (item.value === application.applicationType) {
                    this.detailsForm.get(this.applicationTypeFormControlName).setValue(item);
                }
            });
            this.detailsForm.get(this.applicationTypeFormControlName).disable();
        }
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.referenceNumber) {
            this.showRefNumber = true;
            this.detailsForm.get(this.referenceNumberControlName).enable();
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.referenceNumberControlName).disable();
        }
        else {
            this.showRefNumber = false;
        }
        this.updateRequiredFields();
        if (this.applicationType === "Alienation") {
            if (application.saleAmount) {
                this.detailsForm.get(this.saleAmountAlienationFormControlName).setValue(application.saleAmount);
            }
            if (application.evaluationAmount) {
                this.detailsForm.get(this.evaluationAmountAlienationFormControlName).setValue(application.evaluationAmount);
            }
            if (application.dateOfDeedTransfer) {
                this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).setValue(this.datePipe.transform(application.dateOfDeedTransfer, "yyyy-MM-dd"));
            }
            this.getBuyers(application.jobId);
        }
        if (this.applicationType === "Lease") {
            if (application.leaseType) {
                this.leaseTypes.forEach(item => {
                    if (item.value === application.leaseType) {
                        this.detailsForm.get(this.leaseTypeFormControlName).setValue(item);
                    }
                });
            }
            if (application.leaseReason) {
                this.detailsForm.get(this.leaseReasonFormControlName).setValue(application.leaseReason);
            }
            if (application.leaseLesseeType) {
                this.lesseeTypes.forEach(item => {
                    if (item.value === application.leaseLesseeType) {
                        this.detailsForm.get(this.lesseeTypeFormControlName).setValue(item);
                    }
                });
            }
            if (application.leaseAreas) {
                this.leaseAreaDrawn = application.leaseAreas.length > 0 ? true : false;
            }
            this.getLessees(application.jobId);
        }
        if (this.applicationType === "Acquisition") {
            if (application.saleAmount) {
                this.detailsForm.get(this.saleAmountFormControlName).setValue(application.saleAmount);
            }
            if (application.evaluationAmount) {
                this.detailsForm.get(this.evaluationAmountFormControlName).setValue(application.evaluationAmount);
            }
            if (application.dateOfDeedTransfer) {
                this.detailsForm.get(this.dateofDeedTransferFormControlName).setValue(this.datePipe.transform(application.dateOfDeedTransfer, "yyyy-MM-dd"));
            }
            this.getSellers(application.jobId);
        }
    }
    getLessees(jobId) {
        this.propertyAndLeaseService
            .getLesseesObservable(jobId)
            .subscribe((response) => this.onGetLesseesCompleted(response), (error) => {
            this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLesseesCompleted(response) {
        if (response && response.value.length > 0) {
            const lesseeControl = this.detailsForm.get(this.lesseeFormControlName);
            RecipientUtils.setRecipients(response.value, false, lesseeControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    getSellers(jobId) {
        this.propertyAndLeaseService
            .getSellersObservable(jobId)
            .subscribe((response) => this.onGetSellersCompleted(response), (error) => {
            this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetSellersCompleted(response) {
        if (response && response.value.length > 0) {
            const sellerControl = this.detailsForm.get(this.sellerFormControlName);
            RecipientUtils.setRecipients(response.value, false, sellerControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    getBuyers(jobId) {
        this.propertyAndLeaseService
            .getBuyersObservable(jobId)
            .subscribe((response) => this.onGetBuyersCompleted(response), (error) => {
            this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetBuyersCompleted(response) {
        if (response && response.value.length > 0) {
            const buyerControl = this.detailsForm.get(this.buyerFormControlName);
            RecipientUtils.setRecipients(response.value, false, buyerControl);
            this.changeDetectorRef.detectChanges();
        }
    }
    updateRequiredFields() {
        if (this.applicationType === "Lease") {
            this.detailsForm.get(this.leaseTypeFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.leaseReasonFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.lesseeTypeFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.lesseeFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.saleAmountAlienationFormControlName).clearValidators();
            this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).clearValidators();
            this.detailsForm.get(this.evaluationAmountAlienationFormControlName).clearValidators();
            this.detailsForm.get(this.buyerFormControlName).clearValidators();
            this.detailsForm.get(this.saleAmountFormControlName).clearValidators();
            this.detailsForm.get(this.dateofDeedTransferFormControlName).clearValidators();
            this.detailsForm.get(this.evaluationAmountFormControlName).clearValidators();
            this.detailsForm.get(this.sellerFormControlName).clearValidators();
        }
        else if (this.applicationType === "Alienation") {
            this.detailsForm.get(this.saleAmountAlienationFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.evaluationAmountAlienationFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.buyerFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.leaseTypeFormControlName).clearValidators();
            this.detailsForm.get(this.leaseReasonFormControlName).clearValidators();
            this.detailsForm.get(this.lesseeTypeFormControlName).clearValidators();
            this.detailsForm.get(this.lesseeFormControlName).clearValidators();
            this.detailsForm.get(this.saleAmountFormControlName).clearValidators();
            this.detailsForm.get(this.dateofDeedTransferFormControlName).clearValidators();
            this.detailsForm.get(this.evaluationAmountFormControlName).clearValidators();
            this.detailsForm.get(this.sellerFormControlName).clearValidators();
        }
        else if (this.applicationType === "Acquisition") {
            this.detailsForm.get(this.saleAmountFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.dateofDeedTransferFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.evaluationAmountFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.sellerFormControlName).setValidators(Validators.required);
            this.detailsForm.get(this.saleAmountAlienationFormControlName).clearValidators();
            this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).clearValidators();
            this.detailsForm.get(this.evaluationAmountAlienationFormControlName).clearValidators();
            this.detailsForm.get(this.buyerFormControlName).clearValidators();
            this.detailsForm.get(this.leaseTypeFormControlName).clearValidators();
            this.detailsForm.get(this.leaseReasonFormControlName).clearValidators();
            this.detailsForm.get(this.lesseeTypeFormControlName).clearValidators();
            this.detailsForm.get(this.lesseeFormControlName).clearValidators();
        }
        this.detailsForm.get(this.saleAmountFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.dateofDeedTransferFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.evaluationAmountFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.sellerFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.saleAmountAlienationFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.dateofDeedAlienationTransferFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.evaluationAmountAlienationFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.buyerFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.leaseTypeFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.leaseReasonFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.lesseeTypeFormControlName).updateValueAndValidity();
        this.detailsForm.get(this.lesseeFormControlName).updateValueAndValidity();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: PropertyAndLeaseService },
        { type: DatePipe }
    ];
};
CreateApplicationDetailsPlamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-plams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsPlamsComponent);
